import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Root from './Root';
import * as serviceWorker from './serviceWorker';
import configureStore from './store/configureStore';
import {cacheState, loadCachedState} from './store/cache';

/* load and configure react-redux store, then render the app's Root element */
const store = configureStore(loadCachedState());
store.subscribe(() => {
    cacheState(store);
});

ReactDOM.render(<Root store={store} />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
